import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firebaseAuth } from './config/constants'
import { getUserInfo } from './helpers/auth'
import { getSubscription, updateSubscription } from './helpers/subscription'
import { saveUserToState } from './reducers/user'
import { fetchWatchlist } from './reducers/watchlist'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import Header from './components/Header'
import Home from './components/Home'
import Pricing from './components/Pricing'
import Blogs from './components/Blogs'
import Blogger from './components/Blogger'
import AboutUs from './components/AboutUs'
import Login from './components/Login'
import Register from './components/Register'
import Dashboard from './components/Dashboard'
import Leaderboard from './components/Leaderboard'
import Subscription from './components/Subscription'
import Ticker from './components/Ticker'
import NotFound from './components/NotFound'
import Page from './Pages/Page'

function PrivateRoute ({component: Component, authed, plan, ...rest}) {
  // debugger;
  if (authed === true) {
    if (plan === 'active' && rest.path === '/subscription') {
      return (
        <Route {...rest} render={(props) => <Redirect to='/dashboard' />}/>
      )
    }

        return (
        <Route {...rest} render={
          (props) => <Component {...props} authed={authed} />
        }/>
      )

    // if (plan === 'free' && rest.path !== '/subscription') {
    //   return (
    //     <Route {...rest} render={(props) => <Redirect to='/dashboard' />}/>
    //   )
    //   // return (
    //   //   <Route {...rest} render={(props) => <Redirect to='/subscription' />}/>
    //   // )
    // } else {
    //   return (
    //     <Route {...rest} render={
    //       (props) => <Component {...props} authed={authed} />
    //     }/>
    //   )
    // }
  } else {
    return (
      <Route {...rest} render={
        (props) => <Redirect to={{pathname: '/login', state: {from: props.location}}} />
      }/>
    )
  }
}

function PublicRoute ({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false
        ? <Component {...props} />
        : <Redirect to='/dashboard' />}
    />
  )
}

class App extends Component {

  constructor (props) {
    super(props);

    this.state = {
      currentSymbol: null,
      yahooData: null,
      fmpData: null,
      authed: false,
      loading: true,
    }
  }

  componentDidMount () {
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        getUserInfo(user.uid)
        .then(userInfo => {
          // Save user in redux
          this.props.saveUserToState(userInfo)

          this.setState({
            loading: false
          })
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  componentWillUnmount () {
    this.removeListener()
  }

  render () {
    const { currentUser } = this.props.user

    let authed = null
    let plan = null

    // debugger;
    if (this.state.loading === true) {
      return null
    }

    if (currentUser === null) {
      authed = false
    } else {
      authed = true

      if (currentUser.plan === undefined || currentUser.plan.status === undefined) {
        plan = 'free'
      } else {
        getSubscription(currentUser.plan.id)
        .then(plan => {
          updateSubscription(plan)
        })

        plan = currentUser.plan.status
      }
    }

    return this.state.loading === false && (
      <Router>
        <div className="wrap bg-white-gray">

          <Header authed={authed} />

          <Switch>
            <Route path='/' exact component={Home} />
            <PrivateRoute plan={plan} authed={authed} path='/leaderboard' component={Leaderboard} />
            <PublicRoute plan={plan} authed={authed} path='/login' component={Login} />
            <PublicRoute plan={plan} authed={authed} path='/register' component={Register} />
            <PrivateRoute plan={plan} authed={authed} path='/subscription' component={Subscription} />
            <PrivateRoute plan={plan} authed={authed} path='/dashboard' component={Dashboard} />

            <PrivateRoute
              plan={plan}
              authed={authed}
              path='/quote/:ticker'
              component={Ticker}
              symbol={this.state.currentSymbol}/>
            <Route path='/pricing' exact component={Pricing} />
            <Route path='/blogs' exact component={Blogs} />
            <Route path='/blogger' exact component={Blogger} />
            <Route path='/aboutus' exact component={AboutUs} />
            <Route path='/privacy' component={Page} />
            <Route path='/terms' component={Page} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>

    )
  }
}

export default connect(
  (state) => ({
    user: state.user
  }),
  {saveUserToState, fetchWatchlist}
)(App)



// WEBPACK FOOTER //
// ./src/App.js